/**
 * Fetch Notification Roadmap Item UseCase
 *
 * Thin delegator for the single roadmap item opened from a notification.
 * Forwards `roadmapItemId` to `roadmapService.fetchNotificationRoadmapItem`
 * and returns its result unchanged — a one-element list (or empty when the
 * item does not exist). No business logic lives here; the DTO→entity mapping
 * and like-state fill stay in the service.
 *
 * Flutter parity:
 *  - lib/presentation/screens/roadmap/roadmap_screen.dart:423-425 (_getData,
 *    the `itemInfo != null` branch): RoadmapRepository().getNotificationRoadmapItem(
 *    widget.itemInfo!.roadmapItemId). Flutter returns a RoadmapResponse whose
 *    `items` holds the single item, hence the list return shape.
 */

import { roadmapService } from '@/domain/services/roadmap/roadmapService';
import type { RoadmapItemEntity } from '@/domain/entities/roadmap/roadmapItemEntity';

export class FetchNotificationRoadmapItemUseCase {
  async execute(roadmapItemId: string): Promise<RoadmapItemEntity[]> {
    return roadmapService.fetchNotificationRoadmapItem(roadmapItemId);
  }
}

export const fetchNotificationRoadmapItemUseCase = new FetchNotificationRoadmapItemUseCase();
